// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICalculateScheduleRequestDto } from './ICalculateScheduleRequestDto';
import {
    ICalculateScheduleRequestDtoFromJSON,
    ICalculateScheduleRequestDtoFromJSONTyped,
    ICalculateScheduleRequestDtoToJSON,
    ICalculateScheduleRequestDtoToJSONTyped,
} from './ICalculateScheduleRequestDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarUpdatePartnerRequestDto
 */
export interface IPayrollCalendarUpdatePartnerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerRequestDto
     */
    calendar_name: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdatePartnerRequestDto
     */
    group_type: IPayrollCalendarUpdatePartnerRequestDtoGroupTypeEnum;
    /**
     * 
     * @type {ICalculateScheduleRequestDto}
     * @memberof IPayrollCalendarUpdatePartnerRequestDto
     */
    calculate_schedule_request_dto: ICalculateScheduleRequestDto;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarUpdatePartnerRequestDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarUpdatePartnerRequestDto
     */
    payroll_group_ids?: Set<number>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdatePartnerRequestDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarUpdatePartnerRequestDto interface.
 */
export function instanceOfIPayrollCalendarUpdatePartnerRequestDto(value: object): value is IPayrollCalendarUpdatePartnerRequestDto {
    if (!('calendar_name' in value) || value['calendar_name'] === undefined) return false;
    if (!('group_type' in value) || value['group_type'] === undefined) return false;
    if (!('calculate_schedule_request_dto' in value) || value['calculate_schedule_request_dto'] === undefined) return false;
    return true;
}

export function IPayrollCalendarUpdatePartnerRequestDtoFromJSON(json: any): IPayrollCalendarUpdatePartnerRequestDto {
    return IPayrollCalendarUpdatePartnerRequestDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarUpdatePartnerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarUpdatePartnerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_name': json['calendar_name'],
        'group_type': json['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoFromJSON(json['calculate_schedule_request_dto']),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'payroll_group_ids': json['payroll_group_ids'] == null ? undefined : new Set(json['payroll_group_ids']),
    };
}

export function IPayrollCalendarUpdatePartnerRequestDtoToJSON(json: any): IPayrollCalendarUpdatePartnerRequestDto {
    return IPayrollCalendarUpdatePartnerRequestDtoToJSONTyped(json, false);
}

export function IPayrollCalendarUpdatePartnerRequestDtoToJSONTyped(value?: IPayrollCalendarUpdatePartnerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_name': value['calendar_name'],
        'group_type': value['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoToJSON(value['calculate_schedule_request_dto']),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'payroll_group_ids': value['payroll_group_ids'] == null ? undefined : Array.from(value['payroll_group_ids'] as Set<any>),
    };
}

